import { MaterialIcons } from '@fhs/material-icons';

export const sharedCachedFonts = {
  // Font Icons
  // we have to include them directly in the assets folder of the apps instead of requiring them
  // locally to workaround strange font loading issues in development.
  MaterialIcons,
};
